'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userIngredientForm = require('./user-ingredient-form.html');

var _userIngredientForm2 = _interopRequireDefault(_userIngredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _userIngredientForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    ingredient: '<',
    dialogTitle: '@',
    submitTitle: '@',
    ingredientChanged: '&'
  },
  controller: function () {
    function UserIngredientFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, UserIngredientFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(UserIngredientFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.ingredientChanged(this.EventEmitter({
          ingredient: this.ingredient
        }));
      }
    }]);

    return UserIngredientFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredient-form/user-ingredient-form.component.js